import config from "../../helper/config";
import APIHandler from "../../handlers/APIHandler";

export const CandidateExamService = {
  getPublishedExams,
  getExamMetaData,
  loadExamPaper,
  preparePublishedExam,
  loadAssessmentQuestions,
  validateCandidate,
  startTimer,
  getCandidateAnswers,
  saveCandidateAnswers,
  finishTest,

  getReport,
  saveMarks,
  finalizeGrade,
  selfFinalizeGrade,
  restartExam,
  getRestartPauseStatus,
  finalizeAutoGrade,

  getAllAnswerContents,
  autoGradeIfNeeded,
  getAllLastAttempt,
  addCandidateAttempts,
};

async function getAllAnswerContents({ questions = [] }) {
  const contents = questions.map((question) => {
    return question.answer;
  });

  return contents;
}
async function finishTest({ candidate_id, is_all_mcq = false }) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify({
      candidate_status: "Finished",
      is_all_mcq,
    }),
  };

  return fetch(
    `${config.oat_api_url}/candidate/exams/finishTest/${candidate_id}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function saveCandidateAnswers(payload = []) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };

  return fetch(
    `${config.oat_api_url}/candidate/answers/addAll/`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function preparePublishedExam(exam) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify({
      assessment_id: exam.assessment_id || exam.id,
      user_id: sessionStorage.getItem("user_id"),
      no_of_attempts: exam.no_of_attempts || 1,
      parent_user_id: exam.parent_user_id || null,
      node_mid: exam.node_mid || null,
      is_try_again: exam.is_try_again || false,
    }),
  };

  return fetch(
    `${config.oat_api_url}/candidate/exams/new/preparePublishedExam`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function validateCandidate(candidateId) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  return fetch(
    `${config.oat_api_url}/candidate/exams/new/validateCandidate/${candidateId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function startTimer({ candidate_id, assessment_id, attempt_no }) {
  const requestOptions = {
    method: "POST",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    body: JSON.stringify({
      candidate_id,
      assessment_id,
      attempt_no,
    }),
  };

  return fetch(
    `${config.oat_api_url}/candidate/grade/reports/add/`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function getCandidateAnswers(candidateId) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  return fetch(
    `${config.oat_api_url}/candidate/answers/getAnswers/${candidateId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function loadExamPaper(assessment_id) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  return fetch(
    `${config.oat_api_url}/candidate/exams/loadQuestions/${assessment_id}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function loadAssessmentQuestions(assessment_id) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  return fetch(
    `${config.oat_api_url}/candidate/exams/new/getAllQuestions/${assessment_id}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function getExamMetaData() {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  return fetch(
    `${config.oat_api_url}/assessment_new/new-meta-data`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function getPublishedExams(params = {}) {
  const {
    user_id = sessionStorage.getItem("user_id"),
    limit = 10,
    offset = 0,
    search_term = "",
    sort_column = "created_at",
    sort_direction = "desc",
    selectedCategories = "null",
    selectedAuthors = "null",
    selectedChapters = "null",
    selectedGrades = "null",
    selectedDifficulties = "null",
    selectedLanguages = "null",
    selectedTerms = "null",
    selectedYears = "null",
    selectedsubjects = "null",
    selectedExamCategories = "null",
    selectedSources = "null",
    selectedCreators = "null",
    selectedStartDate = "null",
    selectedEndDate = "null",
  } = params;

  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  const query = new URLSearchParams({
    user_id,
    limit,
    offset,
    search_term,
    sort_column,
    sort_direction,
    selectedCategories,
    selectedAuthors,
    selectedChapters,
    selectedGrades,
    selectedDifficulties,
    selectedLanguages,
    selectedTerms,
    selectedYears,
    selectedsubjects,
    selectedExamCategories,
    selectedSources,
    selectedCreators,
    selectedStartDate,
    selectedEndDate,
  });

  return fetch(
    `${config.oat_api_url}/candidate/exams/new/getPublishedExams?${query.toString()}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function getReport({ candidate_id, attempt_no }) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  return fetch(
    `${config.oat_api_url}/candidate/grade/reports/get/${candidate_id}/${attempt_no}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function saveMarks(payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    // body: JSON.stringify({
    //   ...payload,
    //   assessor_remarks: JSON.stringify(payload.assessor_remarks || {}),
    // }),

    body: JSON.stringify({
      ...payload,
      questions: Array.isArray(payload.questions)
        ? payload.questions
        : Object.values(payload.questions || {}),
      assessor_remarks: JSON.stringify(payload.assessor_remarks || {}),
    }),
  };

  return fetch(
    `${config.oat_api_url}/candidate/answers/saveMarks/`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function selfFinalizeGrade(payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };

  return fetch(
    `${config.oat_api_url}/candidate/grade/reports/selfFinalize/`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function finalizeGrade(payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };

  return fetch(
    `${config.oat_api_url}/candidate/grade/reports/finalize/`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function finalizeAutoGrade(payload) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };

  return fetch(
    `${config.oat_api_url}/candidate/grade/reports/finalizeAutoGrade/`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function autoGradeIfNeeded({ candidate_id }) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
  };

  return fetch(
    `${config.oat_api_url}/candidate/exams/new/autoGradeIfNeeded/${candidate_id}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function getAllLastAttempt(userId, assessmentId) {
  const requestOptions = {
    method: "GET",
    headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
  };

  return fetch(
    `${config.oat_api_url}/candidates/getBy/${userId}/${assessmentId}`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function addCandidateAttempts(attempts) {
  const requestOptions = {
    method: "POST",
    headers: {
      ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
      "Content-Type": "application/json",
    },
    body: typeof attempts === "string" ? attempts : JSON.stringify(attempts),
  };

  return fetch(
    `${config.oat_api_url}/candidates/add/all`,
    requestOptions
  ).then(APIHandler.handleResponse);
}

async function restartExam(candidate_id) {
    const requestOptions = {
        method: 'POST',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name)
    };
    return await fetch(`${config.oat_api_url}/candidate/exams/new/restart/${candidate_id}`, requestOptions)
        .then(APIHandler.handleResponse);
}

async function getRestartPauseStatus(assessment_id){
    const requestOptions = {
        method:'GET',
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name)
    };
    const responce = await fetch(`${config.oat_api_url}/assessments/get_restart_pause_status/${assessment_id}`, requestOptions).then(APIHandler.handleResponse);
    console.log("responce is",responce);
    return responce;

}